import { parseToken, windowExists } from '@classity-edtech/ui-base';
import { Roles } from '../utils/enum';
import { useGetProfileQuery, useGetUserQuery } from '../services/profile';

const useCurrentUser = () => {
  const token =
    windowExists &&
    parseToken(
      (windowExists?.localStorage as { getItem: (key: string) => void })?.getItem('token'),
    );

  const {
    data: user,
    isLoading: loadingUser,
    refetch: refetchUser,
    isUninitialized: isUninitializedUser,
  } = useGetUserQuery({ userId: token.user }, { skip: !token.user });
  const {
    data: profile,
    isLoading: loadingProfile,
    refetch: refetchProfile,
    isUninitialized: isUninitializedProfile,
  } = useGetProfileQuery({ userId: token.user }, { skip: !token.user });

  const refetch = () => {
    if (!isUninitializedUser) refetchUser();
    if (!isUninitializedProfile) refetchProfile();
  };

  const initials = `${profile?.firstname[0]}${profile?.lastname[0]}`;

  const isParent = user?.roleId === Roles.PARENT;
  const isStudent = user?.roleId === Roles.STUDENT;

  return {
    user: { ...user, ...profile },
    isLoading: loadingUser || loadingProfile,
    refetch,
    initials,
    isParent,
    isStudent,
  };
};

export default useCurrentUser;
